/* eslint-disable jsx-a11y/alt-text */
import React from "react";

import source from "../../assets/app-config.json";
import "./styles.scss";
import android from "../../assets/android.svg";
import iphone from "../../assets/apple.svg";
import appImage from "../../assets/app.png";

function openLink(platform) {
  var download;

  if (platform === "android") {
    download = source.linkAndroid;
  } else {
    download = source.linkApple;
  }
  window.open(download);
}

export default function index() {
  return (
    <div
      className="background"
      style={{ backgroundColor: `${source.backgroundcolor}` }}
    >
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-lg-6">
            <h1>{source.title}</h1>
            <h2>{source.head}</h2>
            <h4>{source.description}</h4>
            <div className="row">
              <div className="col-md-12 col-lg-6">
                <div
                  className="actionButton"
                  href="#"
                  style={{ backgroundColor: `${source.backgroundcolor}` }}
                  onClick={() => openLink("android")}
                >
                  <img src={android} />
                  Baixar para Android
                </div>
              </div>
              <div className="col-md-12 col-lg-6">
                <div
                  className="actionButton"
                  href="#"
                  style={{ backgroundColor: `${source.backgroundcolor}` }}
                  onClick={() => openLink("iphone")}
                >
                  <img src={iphone} />
                  Baixar para iPhone
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 col-lg-6">
            <div className="phone-app">
              <img src={appImage} className="img-fluid"></img>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
